import React, { useEffect, useRef, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Formik, Field, FieldArray, Form as FormikForm, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { AiOutlineDelete } from 'react-icons/ai';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomCheckboxDropdown from '../../components/forms/checkBoxDropDown';
import successToast from '../../components/toasts/successToast';
import CustomButton from '../../components/button/button';
import { availableLanguages } from '../../components/data/languageData';
import { useDispatch } from 'react-redux';
import { assignTeamAction, teamsDropDown } from '../../redux/actions/documentAction';
import errorToast from '../../components/toasts/errorToast';


const AssignedTeams = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [teams, setTeams] = useState([]);
    const location = useLocation();
    const selectedDocuments = location.state?.selectedItems || [];
    const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
    const dropdownRefs = useRef([]);


    useEffect(() => {
        dispatch(teamsDropDown({}, (data) => { setTeams(data?.data?.data) }, onError))
    }, []);

    const onError = (data) => {
        errorToast(data?.data?.message)
    }

    const validationSchema = Yup.object({
        teams: Yup.array().of(
            Yup.object({
                id: Yup.string().required('Team is required'),
                target_lang: Yup.array().min(1, 'At least one Target Language is required'),
                comments: Yup.string().required('Comments is required'),
                target_date: Yup.date().required('Target Date is required'),

            })
        ),
    });

    const initialValues = {
        teams: [{
            id: '',
            target_lang: '',
            comments: '',
            target_date: '',
        }],
        documents: selectedDocuments
    };

    const onSubmit = (values) => {
        console.log('Form data', values);
        dispatch(assignTeamAction(values, onAssignSuccess, onError))
    }

    const onAssignSuccess = (data) => {
        successToast(data.data.message);
        navigate('/documents')
    }

    console.log(selectedDocuments, 'selectedDocuments IN ASSIGN PAGE');

    // const [dropdownOpen, setDropdownOpen] = useState(false);
    // const dropdownRef = useRef(null);

    // const handleClickOutside = (event) => {
    //     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
    //         setDropdownOpen(false);
    //     }
    // };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRefs.current.every(
                    (ref) => ref && !ref.contains(event.target)
                )
            ) {
                setOpenDropdownIndex(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    return (
        <div className="flex-grow-1 vh-100 overflow-auto">
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {({ values, setFieldValue, handleSubmit, isValid, dirty }) => (
                    <Form className=" h-100 justify-content-between" onSubmit={handleSubmit}>
                        <div className="w-100 ">
                            <FieldArray name="teams">
                                {({ push, remove }) => (
                                    <>
                                        <div className="w-100 d-flex header border-bottom align-items-center justify-content-between position-sticky top-0 bg-white py-2 z-1">
                                            <h2 className="fs_20 fw_400 fn_Roboto text-start px-3 pt-1 justify-content-between">Assign teams</h2>
                                            <Button
                                                className='d-flex align-items-center justify-content-end mx-3'
                                                style={{ cursor: 'pointer', height: '2rem' }}
                                                onClick={() => push({ id: '', target_lang: [], target_date: '', comments: '' })}
                                            >
                                                Add Team
                                            </Button>
                                        </div>
                                        {values.teams.map((_, index) => (
                                            <div key={index} className="mb-3 mt-1" style={{ borderBottom: '1px solid #ddd', paddingBottom: '10px', marginBottom: '10px' }}>
                                                <p className='text-start px-3 fs_16 fw_600'>Team {index + 1}</p>
                                                <div className="d-flex flex-wrap">
                                                    <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                                                        <label htmlFor={`id-${index}`} className="py-1">Team</label>
                                                        <div className="d-flex position-relative">
                                                            <Field
                                                                name={`teams[${index}].id`}
                                                                as="select"
                                                                className="input-field"
                                                                id={`id-${index}`}
                                                                style={{ width: '20rem' }}
                                                            >
                                                                <option value="">Select a team</option>
                                                                {teams.length > 0 && teams?.map((team) => (
                                                                    <option key={team.id} value={team.id}>
                                                                        {team.name}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </div>
                                                        <ErrorMessage name={`teams[${index}].id`} component="div" className="text-danger mt-1 fs_12" />
                                                    </div>
                                                    <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                                                        <label htmlFor={`target_date-${index}`} className="py-1">Target Date</label>
                                                        <div className="d-flex position-relative">
                                                            <Field
                                                                name={`teams[${index}].target_date`}
                                                                type="datetime-local"
                                                                className="input-field"
                                                                id={`target_date-${index}`}
                                                                style={{ width: '20rem' }}
                                                                min={new Date().toISOString().slice(0, 16)}
                                                            />
                                                        </div>
                                                        <ErrorMessage name={`teams[${index}].target_date`} component="div" className="text-danger mt-1 fs_12" />
                                                    </div>
                                                    <div className="d-flex gap-3 me-4 align-items-center">
                                                        {values.teams.length > 1 && (
                                                            <AiOutlineDelete
                                                                style={{ width: '25px', height: '25px', color: 'red' }}
                                                                onClick={() => remove(index)}
                                                                className="mt-4 cursor_pointer"
                                                            />
                                                        )}
                                                    </div>

                                                </div>
                                                <div className='d-flex flex-wrap'>
                                                    {/* <div className="text-start gap-3 mb-2 text-nowrap mx-4" ref={dropdownRef}>
                                                        <label htmlFor={`target_lang-${index}`} className="py-1">Target Language</label>
                                                        <div className="custom-dropdown">
                                                            <CustomCheckboxDropdown
                                                                options={availableLanguages}
                                                                name={`teams[${index}].target_lang`}
                                                                value={values.teams[index].target_lang}
                                                                onChange={(field, value) => setFieldValue(field, value)}
                                                                placeholder={'Select Target Language'}
                                                                dropdownOpen={dropdownOpen}
                                                                setDropdownOpen={setDropdownOpen}
                                                            />
                                                        </div>
                                                        <ErrorMessage name={`teams[${index}].target_lang`} component="div" className="text-danger mt-1 fs_12" />
                                                    </div> */}
                                                    <div
                                                        className="text-start gap-3 mb-2 text-nowrap mx-4"
                                                        ref={(el) => (dropdownRefs.current[index] = el)}
                                                    >
                                                        <label htmlFor={`target_lang-${index}`} className="py-1">Target Language</label>
                                                        <div className="custom-dropdown">
                                                            <CustomCheckboxDropdown
                                                                options={availableLanguages}
                                                                name={`teams[${index}].target_lang`}
                                                                value={values.teams[index].target_lang}
                                                                onChange={(field, value) => setFieldValue(field, value)}
                                                                placeholder={'Select Target Language'}
                                                                dropdownOpen={openDropdownIndex === index}
                                                                setDropdownOpen={(isOpen) => {
                                                                    setOpenDropdownIndex(isOpen ? index : null);
                                                                }}
                                                            />
                                                        </div>
                                                        <ErrorMessage name={`teams[${index}].target_lang`} component="div" className="text-danger mt-1 fs_12" />
                                                    </div>
                                                    <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                                                        <label htmlFor={`comments-${index}`} className="py-1">Description</label>
                                                        <div className="d-flex position-relative">
                                                            <Field
                                                                name={`teams[${index}].comments`}
                                                                as="textarea"
                                                                className="input-field"
                                                                id={`comments-${index}`}
                                                                style={{ width: '20rem' }}
                                                            />
                                                        </div>
                                                        <ErrorMessage name={`teams[${index}].comments`} component="div" className="text-danger mt-1 fs_12" />
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                )}
                            </FieldArray>
                        </div>
                        <div className="d-flex gap-5 mt-4 mx-4 my-3">
                            <button type="submit" className="btn btn-primary" style={{ width: '5rem' }} disabled={!(isValid && dirty)}>Send</button>
                            <button type="button" className="btn btn-secondary" style={{ width: '5rem' }} onClick={() => navigate('/documents')}>Cancel</button>
                        </div>
                    </Form>

                )}
            </Formik>
        </div>
    );
};

export default AssignedTeams;
